module.exports = __webpack_public_path__ + "static/reactive-localization-b7ce831c3133dbdc8ffb7188fbd33c8d.png";